import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { useStores } from '../../data/store'

export const UploadEntityFile = (props: any) => {
  const { setMessage } = useStores((store) => ({
    setMessage: store.message.setMessage,
  }))

  const inputBoxConfig = () => ({
    element: document.createElement('input'),
    type: 'file',
  })

  const onFileSelected = (e: any) => {
    const target = e.target as HTMLInputElement
    const file = (target.files as FileList)[0]
    if (file && file.type === 'application/json' && /^[^.]+\.(json|JSON)$/.test(file.name)) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        try {
          const parsedData = JSON.parse(e.target.result)
          if (Array.isArray(parsedData)) {
            const configs = parsedData.map((item) => (typeof item === 'object' ? JSON.stringify(item) : item))
            props?.onChange?.(JSON.stringify(configs))
          } else {
            console.error('Error parsing JSON')
            setMessage('JSON array is expected!')
          }
        } catch (error) {
          console.error('Error parsing JSON', error)
          setMessage('Invalid JSON file!')
        }
      }

      reader.readAsText(file)
    } else {
      setMessage('Please upload a valid JSON file')
    }
  }

  const onSelectFilePress = (): void => {
    const inputBoxConfigTemp = inputBoxConfig()
    const inputBox = inputBoxConfigTemp.element
    inputBox.type = inputBoxConfigTemp.type
    inputBox.accept = '.json,.JSON'
    inputBox.draggable = true
    inputBox.click()
    inputBox.onchange = onFileSelected
  }
  return (
    <Box {...styles.container}>
      <Text {...styles.label}>Upload Processor Configuration</Text>
      <Box {...styles.button} onPress={onSelectFilePress}>
        <Text {...styles.buttonTitle}>Choose File</Text>
      </Box>
      <Text {...styles.subHeading}> ** Only JSON is accepted. </Text>
      {props?.value?.length > 0 && <Text {...styles.success}> Document selected sucessfully.</Text>}
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'column',
  } as BoxProps,
  label: {
    fontSize: 12,
    color: '#757575' as ColorOptions,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  button: {
    height: 35,
    marginTop: 12,
    marginBottom: 8,
    backgroundColor: '#efefef' as any,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#D1D3E2' as any,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  buttonTitle: {
    fontSize: 12,
    color: 'BLACK_21',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  subHeading: {
    color: 'BLACK_75',
    fontFamily: 'jioType-medium',
    fontSize: 12,
  } as TextProps,
  success: {
    color: 'HAZY_GREEN',
    fontFamily: 'jioType-bold',
    fontSize: 12,
  } as TextProps,
}
